import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg leading-7 font-medium" }, "Choose how to trigger this workflow:", -1)

import TriggerCard from "@/components/workflows/TriggerCard.vue"
import ContactActivityTriggerSidebar from "@/components/workflows/sidebar/trigger/ContactActivityTriggerSidebar.vue"
import { Component } from "vue"
import ScheduleTriggerSidebar from "@/components/workflows/sidebar/trigger/schedule/ScheduleTriggerSidebar.vue"

interface Props {
    modelValue: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'EnrolmentTriggersSidebar',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "changeAction"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

function changeAction(sidebarComponent: Component) {
    emit("changeAction", {
        sidebarComponent,
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(TriggerCard, {
      title: "Trigger on contact activity",
      example: "When a website visitor fills out a form on the contact page of your website",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (changeAction(ContactActivityTriggerSidebar)))
    }),
    _createVNode(TriggerCard, {
      title: "Schedule trigger",
      example: "enroll all contacts at a certain time",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (changeAction(ScheduleTriggerSidebar)))
    })
  ]))
}
}

})